import {Box, Typography} from '@mui/material';

import {FONT_FAMILIES} from '../../../const';
import SecretsByConnector from '../SecretsByConnector/SecretsByConnector';
import {groupBy} from '../utils';

// eslint-disable-next-line react/prop-types
const SecretsByCategory = ({secrets, connectors}) => {
  const grouped = groupBy(secrets, 'category');

  return (
    <Box mt={2} width="100%">
      {Object.entries(grouped).map(([category, categorySecrets]) => (
        <Box key={category} mb={3.5}>
          <Typography fontFamily={FONT_FAMILIES.TITLE} fontSize={22}>
            {category}
          </Typography>

          <SecretsByConnector secrets={categorySecrets} connectors={connectors} />
        </Box>
      ))}
    </Box>
  );
};

export default SecretsByCategory;
